import React, { Component } from "react";
import "./ExperienceBadge.css";
import { api } from "api";
import { number } from "@amcharts/amcharts4/core";
import { Cursor } from "@amcharts/amcharts4/charts";

class ExperienceBadge extends Component {
    constructor() {
        super();
        this.state = {
            years: 0,
            color: "#9e9e9e",
            isLoaded: false,
            day: number
        };
    }

    componentDidMount() {
        this.calculateExperience();
    }


    calculateExperience = async () => {
        try {

            if (localStorage.getItem("token") == null) {
                this.setState({ isLoaded: false });
                return
            }
            else {
                const response = await api.get("/api/profile/get");
                if (response.status === 200 && response.data?.data) {
                    const days = response.data.data.fordFamilySeniorityDay || 0;
                    const years = Math.round(days / 365);
                    const color = this.getColorByYears(years);
                    this.setState({ years, color, isLoaded: true, days });
                }
            }

        } catch (error) {
            this.setState({ isLoaded: false });
        }
    };



    getColorByYears = (years) => {
        if (years < 1) return "#b0bec5";   // Gri - Yeni
        if (years < 3) return "#64b5f6";   // Açık mavi - Gelişim
        if (years < 5) return "#81c784";   // Yeşil - Deneyimli
        if (years < 8) return "#ffb74d";   // Turuncu - Kıdemli
        if (years < 12) return "#f06292";  // Pembe - Uzman
        if (years < 20) return "#ba68c8";  // Mor - Usta
        return "#ffd700";                  // Altın - Efsane
    };

    render() {
        const { years, color } = this.state;


        return (
            this.state.days > 365 ?

                <div className="ribbon-badge" style={{ cursor: "default" }} title="Ford Kıdem Yılı">
                    <div className="inner">
                        <div className="text-container">
                            <span className="year-number">{years}.</span>
                            <span className="year-label">YIL</span>
                        </div>
                    </div>

                    <div className="tail"></div>
                </div>



                : null
        );
    }
}

export default ExperienceBadge;